var React = require('react');

function FrontendDropdownMenuTransactional (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M11 9.5v-3.5h-11v-2h11v-3.5l4.5 4.5-4.5 4.5zM5 10h11v2h-11v3.5l-4.5-4.5 4.5-4.5v3.5z"}));
}

FrontendDropdownMenuTransactional.displayName = "FrontendDropdownMenuTransactional";

FrontendDropdownMenuTransactional.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendDropdownMenuTransactional;

FrontendDropdownMenuTransactional.default = FrontendDropdownMenuTransactional;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-dropdown-menu-transactional.svg
// module id = 1010
// module chunks = 0